import './ExperienceComponent.css';
import Photos from "./Photos"
import Capsule from "./Capsule"


function ExperienceComponent(prop) {
  let experiences = require("./Resources/experiences");
  let experience = []
  for (let i = 0; i < experiences.experiences.length; i++) {
    if (experiences.experiences[i].link === prop.link) {
        experience = experiences.experiences[i]
        break
    }
  }

 return (
    <div className="ExperienceComponent">
            <div className="flex-container">
                <div className="scrollPane">

                    <h1>{experience.name}</h1>
                    <hr/>
                    <p>When: {experience.date}</p>
                    <hr/>
                    <h5>
                    Description:
                    </h5>
                    <p>{experience.desc}</p>
                    <h5>
                    <hr/>
                    Technologies/Skills
                    </h5>
                    {experience.technologies.map((item) => (
                        <Capsule value={item}/>
                    ))}


                </div>
                <div className="carouselWrapper">
                    <Photos key={experience.name + "photo"} photosArr={experience.media}/>
                </div>
                </div>

    </div>
 );
 }


export default ExperienceComponent;
